import TickIcon from "@/assets/colorable/tick.svg?react";
import {times} from "lodash";
import {type FC, type SVGProps} from "react";

const CompletionMarkers: FC<{
  completedCount?: number;
  Icon: FC<SVGProps<SVGSVGElement>>;
  label: string;
  requiredCount?: number;
  showDivider?: boolean;
}> = ({completedCount = 0, Icon, label, requiredCount = 0, showDivider}) => {
  if (!requiredCount && !completedCount) {
    return null;
  }

  return (
    <div className="flex">
      <div className="flex flex-col gap-1">
        <div className="flex gap-2">
          {times(requiredCount || completedCount).map(value =>
            completedCount && value < completedCount ? (
              <div
                key={value}
                className="bg-success-light-green border-success-herbal flex size-8 items-center justify-center rounded-lg border">
                <TickIcon className="text-success-herbal size-4" />
              </div>
            ) : (
              <div
                key={value}
                className="bg-danger-light-red border-danger-medium-red flex size-8 items-center justify-center rounded-lg border">
                <Icon className="text-danger-medium-red size-4.5" />
              </div>
            ),
          )}
        </div>
        <span className="text-neutral-black text-2xs">{`${completedCount} / ${requiredCount} ${label}`}</span>
      </div>
      {showDivider && <div className="bg-primary-light-solid mx-5 h-full w-px" />}
    </div>
  );
};

export default CompletionMarkers;
